import type { FaireThemeEntity } from "../../entity_types/theme";

export const elemental_flow_and_vitality: FaireThemeEntity = {
  token: "elemental-flow-and-vitality",
  type: "theme",
  name: "Elemental Flow & Vitality",
  description: "Incorporate the grounded energy of copper into your wellness section. These spheres are associated with vitality and conductivity, offering a unique metallic contrast to your gemstone collection.",
  teaser: "With established interests in 'crystal healing' and 'therapeutic bodywork,' your customers are likely searching for tools that promote physical and spiritual flow.",
  detail: "The copper spheres in the payload are specifically highlighted for their association with flow and vitality, providing a specific metaphysical benefit for your wellness-focused patrons.",
  bgColor: "#D4F0E4",
  tileBgColor: "#39676b",
  exactProducts: true,
  retailerToken: "r_31m33roqxk",
  productTokens: [
    "p_4qpolmb6l7",
    "p_yxbgbmypsx",
    "p_vky92s65yd",
    "p_3yhcdrsywq",
    "p_s8fwvuhx9a",
    "p_9mjc7rd579",
    "p_xcgwmm86mh",
    "p_4k6668j6u6",
    "p_34x2k2seq5",
    "p_yekgpnugnw",
    "p_xq7fhjdasy",
    "p_qbmn3vbneu",
    "p_an38x4bbyx",
    "p_q5486sst2u",
    "p_arrmtv54mm",
    "p_mzzckmkk2m",
    "p_a7481f5nv7",
    "p_n29hf6b3fy",
    "p_s7m6d3zb8j",
    "p_8sz8f69wsw",
    "p_rfrg7a7q4g",
    "p_9f9be7smkt",
    "p_c78rwd7dae",
    "p_7aynmddb8j",
    "p_zfsrsq5szr",
    "p_cxsqdjcb3m",
    "p_da8njh6txf",
    "p_kcmawvb4b9",
    "p_p276vprpdm",
    "p_57qh73ptq3",
    "p_hf723xpyq8",
    "p_tsh6bg44y4",
    "p_hpwwm7sshz",
    "p_h9gjma7fgq",
    "p_xt49b8vta5",
    "p_dxu5evkeme",
    "p_q6skkh4xxa",
    "p_wcms5d6y47",
    "p_vhtfdz73m3",
    "p_p9ea5y74ne",
    "p_cdub6vvt95",
    "p_xw46z5tnsr",
    "p_uqf5z6dyqn",
    "p_4y5vbx4w5v",
    "p_t9ubbgv7jn",
    "p_eu7d23u6sg",
    "p_dymv7mfgpy",
    "p_bnaxct7cg4",
    "p_c7pqjejj3s",
    "p_c268etmvtc",
    "p_gqmbkutm8u",
    "p_4snrc2q249",
    "p_y8vm9y2utm",
    "p_xy6b7mt8hh",
    "p_sngnatw8et",
    "p_ps4666bejp",
    "p_5cp72yb7fk",
    "p_s2xwpcfzm5",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
